import { Text } from '@chakra-ui/react';
import React from 'react';
import Player from '../../classes/Player';

type AccountNameProps = {
  player: Player;
};
export default function AccountName({ player }: AccountNameProps): JSX.Element {
  if (player.accountName !== '') {
    return <Text as='i'>{player.accountName}</Text>;
  }
  return <></>;
}
